import { getProductId } from './../../../order-builder/modules/specification/helpers/product.helper';
import { getOneClickProducts } from './../../selectors/one-click-products.selector';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { Store, select } from '@ngrx/store';
import { OneClickLoadPaymentsFromBuilderProductAction } from '../../actions/one-click-payments.actions';
import { filter, take, map } from 'rxjs/operators';

@Injectable()
export class OneClickLoadProductPayments implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOneClickProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) => products.find((product) => getProductId(product) === value)),
      )
      .subscribe((product) =>
        this.store.dispatch(new OneClickLoadPaymentsFromBuilderProductAction(product, form.mapItem['index'])),
      );
  }
}
